export const getYoutubeEmbedUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    let videoId = null;

    // Handle youtu.be short links
    if (parsedUrl.hostname.includes("youtu.be")) {
      videoId = parsedUrl.pathname.slice(1);
    }

    // Handle watch?v= format
    else if (parsedUrl.pathname === "/watch") {
      videoId = parsedUrl.searchParams.get("v");
    }

    // Handle /shorts/, /embed/, /live/
    else {
      const parts = parsedUrl.pathname.split("/");
      if (parts.length >= 2) {
        videoId = parts[2] || parts[1]; // works for /shorts/ID, /embed/ID etc.
      }
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  } catch {
    return url; // fallback if parsing fails
  }
};
